import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1220px;
  margin: 0 40px;
  display: flex;
  flex-direction: column;
`;

export const Route = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 36px;
  padding: 8px 0;
  border-bottom: 1px solid #888;
`;

export const CollectRequesterTypeTitle = styled.p`
  color: #004e9a;
  font-size: 27px;
  //font-weight: bold;
  text-align: center;
  text-transform: uppercase;
`;

export const CollectRequesterTypeText = styled.p`
  color: #333333;
  font-size: 14px;
  //font-weight: bold;
  text-align: center;
`;

export const TitlePage = styled.div`
  margin-top: 24px;
  padding: 8px 0;
  color: #004e9a;
  font-weight: bold;
  text-align: center;
  font-size: 27px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > span {
    color: #444444;
    font-weight: normal;
    font-size: 14px;
  }

  > hr {
    width: 90px;
    height: 3px;
    background-color: #d58500;
    margin: 10px 0;
    border: none;
  }
`;
